"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
const feed_v2_models_1 = require("@forto-dev/feed-v2-models");
var NewActivityType;
(function (NewActivityType) {
    NewActivityType["Approval"] = "Approval";
    NewActivityType["OpenTasks"] = "OpenTasks";
    NewActivityType["Activity"] = "Activity";
})(NewActivityType || (NewActivityType = {}));
exports.ActivityType = { ...feed_v2_models_1.ActivityType, ...NewActivityType };
//# sourceMappingURL=index.js.map